<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="row">
            <div class="col-12 mb-4">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">{{ isEdicao ? 'Editar Categoria Financeira' : 'Nova Categoria
                            Financeira' }}</h1>
                        <p class="welcome-message">
                            <button mat-icon-button (click)="voltar()">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Preencha os dados abaixo para {{ isEdicao ? 'editar' : 'cadastrar' }} a categoria.
                        </p>
                    </div>
                </div>
            </div>

            @if(isLoading || isLoadingLookups) {
            <div class="col-12">
                <div class="row">
                    <div class="col-12 col-md-6 mb-3">
                        <app-loading-box height="56"></app-loading-box>
                    </div>
                    <div class="col-12 col-md-6 mb-3">
                        <app-loading-box height="56"></app-loading-box>
                    </div>
                    <div class="col-12 col-md-6 mb-3">
                        <app-loading-box height="56"></app-loading-box>
                    </div>
                    <div class="col-12 col-md-6 mb-3">
                        <app-loading-box height="56"></app-loading-box>
                    </div>
                </div>
            </div>
            } @else {
            <div class="col-12">
                <form [formGroup]="form">
                    <div class="row">
                        <div class="col-12 col-md-6 mb-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Nome da Categoria</mat-label>
                                <input matInput type="text" formControlName="descricao"
                                    placeholder="Ex: Material de Escritório" required>
                                @if (form.get('descricao')?.hasError('required')) {
                                <mat-error>O nome da categoria é <strong>obrigatório</strong></mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-6 mb-3">
                            <app-select-pesquisavel label="Categoria Pai (Opcional)"
                                [control]="$any(form).get('idCategoriaPai')" [idField]="'idCategoriaFinanceira'"
                                [nameField]="'descricao'" [offlineList]="categoriasPaiValidas" [isOptional]="true"
                                hint="Selecionar uma categoria caso esta seja uma subcategoria">
                            </app-select-pesquisavel>
                        </div>

                        <div class="col-12 col-md-6 mb-3">
                            <app-select-pesquisavel label="Grupo DRE" [control]="$any(form).get('idTipoCategoriaDre')"
                                [idField]="'idTipoCategoriaDre'" [nameField]="'descricao'" [offlineList]="dreFlatList"
                                [isOptional]="false"
                                hint="O agrupamento DRE indica a alocação do item em relatórios contábeis.">
                            </app-select-pesquisavel>
                        </div>

                        <div class="col-12 col-md-6 mb-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Tipo (Receita/Despesa)</mat-label>
                                <mat-select formControlName="idTipoCategoriaFinanceira" required>
                                    @for (tipo of tiposFinancas; track tipo.idTipoCategoriaFinanceira) {
                                    <mat-option [value]="tipo.idTipoCategoriaFinanceira">
                                        {{ tipo.descricao }}
                                    </mat-option>
                                    }
                                </mat-select>
                                @if (form.get('idTipoCategoriaFinanceira')?.hasError('required')) {
                                <mat-error>O tipo da categoria é <strong>obrigatório</strong></mat-error>
                                }
                            </mat-form-field>
                        </div>

                        <div class="col-12 mb-3">
                            <mat-slide-toggle formControlName="isAtivo" color="primary">
                                {{ form.get('isAtivo')?.value ? 'Ativo' : 'Inativo' }}
                            </mat-slide-toggle>
                        </div>
                    </div>
                </form>
            </div>
            }
        </div>
    </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading || isLoadingLookups" (cancelar)="voltar()"
    (salvar)="salvar()"></app-footer-action>